// The slam window: a fixed pause after every card that lands on the discard pile, during which
// the computer players do nothing, so there's always the same amount of time to press Slam.
// The window is a moment on the local clock, kept outside the shared gameState (each browser
// times its own), and read by BotPlayer (the computers wait) and SlamButton (the countdown).
import { GameState } from "../constants";
import { BotSpeed } from "./types";
import { isPortal } from "../portal";

// Portal players are on phones in a hurry: 2.5 s. The website keeps roughly the pace its
// "computer speed" options always had.
export const slamWindowMs = (botSpeed?: BotSpeed): number => {
  if (isPortal) return 2500;
  return botSpeed === BotSpeed.Normal ? 6000 : 3500;
};

// Did a card just land on the discard pile? The pile grows by one on a discard, a replace, and
// a correct slam. A new round starts with an empty pile, and running the pile back into the
// deck keeps its top card, so neither of those counts.
export const newDiscard = (prev: GameState | undefined, next: GameState | undefined): boolean => {
  const before = prev?.discardPile?.length || 0;
  const after = next?.discardPile?.length || 0;
  if (after === 0) return false;
  if (prev?.round !== next?.round) return false;
  return after > before;
};

// When the slam window closes, given the state before and after an update received at `now`
// (ms). An update that isn't a new discard leaves the window as it was.
export const nextSlamWindowUntil = (
  current: number,
  prev: GameState | undefined,
  next: GameState | undefined,
  now: number
): number => {
  if (!newDiscard(prev, next)) return current;
  return now + slamWindowMs(next?.botSpeed);
};

export const isSlamWindowOpen = (until: number | undefined, now: number): boolean => Boolean(until) && now < (until as number);
